import React, { useEffect, useState } from "react";
import {NavLink} from "react-router-dom";
import SidebarLogo from "../../common/assets/svg/sidebarlogo.svg";
import AutoGrouper from "../../assets/plusNew.png";
import Codie from "../../assets/conversationznew.png";
import Admin from "../../assets/settingNotFill.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Sidebar/Sidebar.css";
import { navigationTree } from "./Service";
import { BiLoader } from "react-icons/bi";
import { useAuth } from "../../authContext/AuthContext";
import axiosInstance from "../../axiosinterceptor";
import CodeAssist from "../../assets/bookNew.png";
import Codeaccelerate from "../../assets/icons8-rocket-64.png";
import CodePlusIcon from "../../common/assets/images/codeplusIcon.png"
import Codeworkflow from "../../assets/menuNew.png";
import Settings from "../../assets/settingsNew.png";
import settings_icon from "../../common/assets/images/settings.png";
import logoutIcon from "../../assets/logoutPNG.png";
import { CircleImg } from "../../common/assets/svg/CircleBlack";
import { ArrowDown } from "../../common/assets/svg/ArrowBlack";
import ArrowRight from "../../common/assets/svg/ArrowRight";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useMediaQuery,
  Box,
  Grid,
  Skeleton,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import { clearCodebookFromIndexedDB } from "../../utils/indexedDB";
import { removeCode } from "../CodingScreen/Service";
 
const Sidebar = ({sidebarOpen,setSidebarOpen}) => {
  const { userEmail } = useAuth();
  const theme = useTheme();
  const SSOLogin_devEnv = process.env.REACT_APP_FLAG_DEV;
  const SSO_DEVURL = "https://hcs.pallas-ai.com.au/login";
  const [openMenus, setOpenMenus] = useState({});
  const [navigationItems, setNavigationItems] = useState();
  const [loading, setLoading] = useState(true);
  const [imageLoading, setImageLoading] = useState(true);
  const name = String(userEmail)?.split("@")[0];
  const [error, setError] = useState("");
  const userId = sessionStorage.getItem("userId");
  const [mobileOpen, setMobileOpen] = useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [hideIcons, setHideIcons] = useState(false);

  // Skeleton loader component for navigation items with rounded rectangles
  const NavigationSkeleton = ({ isSmallScreen, sidebarOpen }) => {
    // Define common navigation items that would typically appear
    const skeletonItems = [
      { icon: true, text: "Code Workflow" },
      { icon: true, text: "Code Accelerate" },
      { icon: true, text: "Code Assist" },
      { icon: true, text: "Code Enhance" },
      { icon: true, text: "Advice Search" },
    ];

    if (isSmallScreen) {
      return (
        <List className="sidebar-companion-toggle-btn">
          {skeletonItems.map((item, index) => (
            <ListItem key={index}>
              <Box
                sx={{
                  fontSize: "10px !important",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Skeleton 
                    variant="rounded" 
                    width={20} 
                    height={20} 
                    sx={{ borderRadius: "4px" }}
                  />
                  <Skeleton 
                    variant="rounded" 
                    width={120} 
                    height={20} 
                    sx={{ borderRadius: "4px" }}
                  />
                </Box>
              </Box>
            </ListItem>
          ))}
        </List>
      );
    }

    // Desktop skeleton with rounded rectangles
    return (
      <ul
        className="sidebar-companion-toggle-btn"
        style={{ paddingLeft: sidebarOpen ? "16px" : "32px" }}
      >
        {skeletonItems.map((item, index) => (
          <li key={index} style={{ marginBottom: "16px" }}>
            <div className="d-flex align-items-center">
              <Skeleton 
                variant="rounded" 
                width={28} 
                height={28} 
                sx={{ 
                  mr: 2, 
                  flexShrink: 0,
                  borderRadius: "6px" 
                }}
              />
              {sidebarOpen && (
                <Skeleton 
                  variant="rounded" 
                  width={120} 
                  height={24} 
                  sx={{ 
                    flexShrink: 0,
                    borderRadius: "4px"
                  }}
                />
              )}
            </div>
          </li>
        ))}
      </ul>
    );
  };

  // Toggle function to open/close submenus
  const toggleMenu = (header) => {
    setOpenMenus((prev) => {
      const isCurrentlyOpen = prev[header];
      const newState = {};
      Object.keys(prev).forEach((key) => {
        newState[key] = false;
      });
      newState[header] = !isCurrentlyOpen;
      return newState;
    });
  };

  useEffect(() => {
    setLoading(true);
    navigationTree()
      .then((items) => {
        const initialMenus = {};
        items.forEach((route) => {
          initialMenus[route.main_Router] = false;
        });
        setOpenMenus(initialMenus);
        setNavigationItems(items);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch navigation items:", error);
        setError("Failed to load navigation");
        setLoading(false);
      });
  }, []);

  const handleSidebarToggle = () => {
    setSidebarOpen((prev) => !prev);
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const getImageSource = (header) => {
    switch (header) {
      case "Code Workflow":
        return Codeworkflow;
      case "Code Accelerate":
        return Codeaccelerate;
      case "Code Assist":
        return CodeAssist;
      case "Code Enhance":
        return AutoGrouper;
      case "Advice Search":
        return Codie;
      case "Admin":
        return Admin;
      case "Codie":
        return Codie;
      case "Settings":
        return Settings;
      case "Settings":
        return settings_icon;
      case "Code Enhance Plus":
        return CodePlusIcon;
      default:
        return "";
    }
  };

  const handleLogoutClick = async () => {
    const redirectUri = SSOLogin_devEnv ? SSO_DEVURL : "";
    const loggoutURL = `https://ap-southeast-2qaj4mzg1x.auth.ap-southeast-2.amazoncognito.com/logout?client_id=2412c4nvn033h8eonph7e5lhfc&logout_uri=${encodeURIComponent(redirectUri)}`;
    sessionStorage.removeItem("initialprincipalDiagnosisState");
    sessionStorage.removeItem("initialadditionalDiagnosisState");
    sessionStorage.removeItem("initialprocedureDiagnosisState");
    setLoading(true);
    try {
      const postapiEndpoint = "";
      const accessToken = sessionStorage.getItem("accessToken");
      const postpayload = {
        body: {
          session_token: accessToken,
        },
      };

      if (postapiEndpoint) {
        await axiosInstance.post(postapiEndpoint, postpayload);
      }

      await clearCodebookFromIndexedDB();

      const loginMethod = localStorage.getItem("LAST_SUCCESSFUL_LOGIN");
      sessionStorage.removeItem("isFetched12");
      sessionStorage.removeItem("isFetched13");
      sessionStorage.removeItem("PENDING_SSO");
      sessionStorage.removeItem("AUTO_SSO_ATTEMPTED");
      sessionStorage.clear();

      if (SSOLogin_devEnv && loginMethod === "SSO") {
        localStorage.setItem("isLoggingOut", "true");
        window.location.href = loggoutURL;
        return;
      }
      window.location.reload();
    } catch (error) {
      console.error("Error in logout request:", error);
      setError(error.message);
      localStorage.removeItem("isLoggingOut");
    } finally {
      setLoading(false);
    }
  };

  const drawerContent = (
    <>
      <Box
        className="w-10 text-white"
        sx={{
          backgroundColor: "#f2f6fc",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Box>
          <Box>
            <Box className="sidebar-wrapper-notification">
              <img className="p-3" src={SidebarLogo} alt="sidebarlogo" />
            </Box>
            <Box className="sidebar-navigation-container">
              {loading ? (
                <NavigationSkeleton isSmallScreen={isSmallScreen} sidebarOpen={sidebarOpen} />
              ) : (
                <List className="sidebar-companion-toggle-btn">
                  {navigationItems?.map((route, index) => (
                    <ListItem key={index}>
                      <Box
                        onClick={() => toggleMenu(route.main_Router)}
                        sx={{
                          fontSize: "10px !important",
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "10px !important",
                        }}
                      >
                        <Box>
                          <img
                            src={getImageSource(route.main_Router)}
                            style={{
                              width: "20px",
                              height: "20px",
                              marginRight: "10px",
                            }}
                            alt="imgsrc"
                            onLoad={() => setImageLoading(false)}
                            onError={() => setImageLoading(false)}
                          />
                        </Box>
                        {route.path &&
                          (!route.children || route.children.length === 0) ? (
                          <NavLink
                            to={`/${route.path}`}
                            style={{
                              color: "#606770",
                              display: "inline-block",
                              paddingRight: "10px",
                              fontWeight: "bolder",
                              fontSize: "12px",
                            }}
                            onClick={() => {
                              if (
                                !route.children ||
                                route.children.length === 0
                              ) {
                                setMobileOpen(false);
                              }
                            }}
                          >
                            {route.main_Router}
                          </NavLink>
                        ) : route?.children && route.children.length > 0 ? (
                          <NavLink
                            to="#"
                            style={{
                              color: "#606770",
                              display: "inline-block",
                              paddingRight: "10px",
                              fontWeight: "bolder",
                              fontSize: "12px",
                            }}
                          >
                            {route.main_Router}
                          </NavLink>
                        ) : (
                          <NavLink
                            to={`/${route.main_Router.toLowerCase()}`}
                            style={{
                              color: "#606770",
                              display: "inline-block",
                              paddingRight: "10px",
                              fontWeight: "bolder",
                              fontSize: "12px",
                            }}
                          >
                            {route.main_Router}
                          </NavLink>
                        )}
                      </Box>
                      {openMenus[route?.main_Router] && route?.children && (
                        <List>
                          {route?.children.map((child, idx) => (
                            <ListItem key={idx}>
                              {child?.name=="Demo"?
                              <a target="_blank" rel="noopener noreferrer" href={child?.path}
                              style={{
                                  fontSize: "15px",
                                  color: "#606770",
                                  display: "inline-block",
                                  paddingRight: "10px",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                }}>{child?.name}s{" "}</a>:<NavLink
                                to={child?.path}
                                style={{
                                  fontSize: "15px",
                                  color: "#606770",
                                  display: "inline-block",
                                  paddingRight: "10px",
                                  fontWeight: "500",
                                  fontSize: "12px",
                                }}
                                onClick={() => setMobileOpen(false)}
                              >
                                {child?.name}
                              </NavLink>}{" "}
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </ListItem>
                  ))}
                </List>
              )}
              <Box className="user-details-container position-absolute bottom-0 w-100">
                <Box className="user-details">
                  <Box className="user-icon-name-row">
                    <Box className="user-icon">
                      <CircleImg />
                    </Box>
                    <Tooltip title={name}>
                      <Box className="user-name">
                        {name?.length > 10 ? `${name.slice(0, 10)}...` : name}
                      </Box>
                    </Tooltip>
                    <Box>
                      <Box className="landingpage-arrow-down">
                        <ArrowDown />
                        <Box className="landingpage-dropdown-content">
                          <Box className="d-flex gap-2 flex-column">
                            <Box
                              className="landing-logout-btn"
                              onClick={handleLogoutClick}
                            >
                              <ArrowRight />
                              {loading ? <BiLoader /> : "Logout"}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="user-email-row">
                    <Tooltip title={userEmail}>
                      <Box className="user-email">{userEmail}</Box>
                    </Tooltip>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );

  return (
    <>
      {isSmallScreen && (
        <>
          <AppBar position="fixed" className="sidebar-mobile-wrapper">
            <Toolbar>
              <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
              <img
                src={SidebarLogo}
                alt="Sidebar Logo"
                style={{ height: 40 }}
              />
            </Toolbar>
          </AppBar>
          <Box component="nav">
            <Drawer
              variant={isSmallScreen ? "temporary" : "permanent"}
              open={isSmallScreen ? mobileOpen : true}
              onClose={handleDrawerToggle}
              ModalProps={{ keepMounted: true }}
              sx={{
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: 250,
                },
              }}
            >
              {drawerContent}
            </Drawer>
          </Box>
        </>
      )}
      {!isSmallScreen && (
        <>
          <div
            className="transition-all duration-100"
            style={{ width: sidebarOpen ? "200px" : "100px" }}
          >
            <div className="main-sidebar position-relative">
              <div>
                <div className="sidebar-wrapper-notification">
                  <img className="p-3" src={SidebarLogo} alt="sidebarlogo" />
                </div>
                <div className="sidebar-navigation-container">
                  {loading ? (
                    <NavigationSkeleton isSmallScreen={isSmallScreen} sidebarOpen={sidebarOpen} />
                  ) : (
                    <ul
                      className="sidebar-companion-toggle-btn"
                      style={{ paddingLeft: sidebarOpen ? "16px" : "32px" }}
                    >
                      {navigationItems
                        ?.filter((route) => route.main_Router !== "Admin")
                        ?.map((route, index) => (
                          <li key={index}>
                            <div
                              style={{ cursor: "pointer" }}
                            >
                              <div className="d-flex align-items-center">
                                <Tooltip
                                  title={!sidebarOpen && route.main_Router}
                                  placement="right"
                                  arrow
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        fontSize: "14px",
                                      },
                                    },
                                  }}
                                >
                                  <img
                                    className="nav-icon"
                                    src={getImageSource(route.main_Router)}
                                    style={{ width: "28px", height: "28px" }}
                                    onClick={() => {
                                      if (sidebarOpen) {
                                        setSidebarOpen(false);
                                      } else {
                                        setSidebarOpen(true);
                                        setOpenMenus((prev) => ({
                                          ...prev,
                                          [route.main_Router]: true,
                                        }));
                                      }
                                    }}
                                    alt="imgsrc"
                                  />
                                </Tooltip>
                                {sidebarOpen && (
                                  <NavLink
                                    to={route.path ? `/${route.path}` : "#"}
                                    className="text-decoration-none"
                                    onClick={(e) => {
                                      if (route.children && route.children.length > 0) {
                                        e.preventDefault();
                                        toggleMenu(route.main_Router);
                                      } else {
                                        setSidebarOpen(false);
                                      }
                                    }}
                                  >
                                    {route.main_Router}
                                  </NavLink>
                                )}
                              </div>
                            </div>
                            {sidebarOpen &&
                              openMenus[route?.main_Router] &&
                              route?.children && (
                                <ul>
                                  {route?.children.map((child, idx) => (
                                    <li
                                      key={idx}
                                      className="ps-4"
                                      onClick={() => setSidebarOpen(false)}
                                    >
                                      {child?.name =="Demo"?
                                      <a target="_blank" rel="noopener noreferrer" href={child?.path} className="text-decoration-none" >{child?.name}</a>:<NavLink
                                        to={child?.path}
                                        className="text-decoration-none"
                                      >
                                        {child?.name}
                                      </NavLink>}
                                    </li>
                                  ))}
                                </ul>
                              )}
                          </li>
                        ))}
                    </ul>
                  )}
                  <div
                    className="user-details-container position-absolute bottom-0 w-100"
                    style={{
                      justifyContent: !sidebarOpen && "center",
                      paddingLeft: sidebarOpen && "16px",
                    }}
                  >
                    {navigationItems
                      ?.filter((route) => route.main_Router === "Admin")
                      .map((route, index) => (
                        <div key={index}>
                          <div style={{ cursor: "pointer" }}>
                            <span onClick={handleSidebarToggle}>
                              <Tooltip
                                title={!sidebarOpen && route.main_Router}
                                placement="right"
                                arrow
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "14px",
                                    },
                                  },
                                }}
                              >
                                <img
                                  src={Admin}
                                  style={{ width: "28px", height: "28px" }}
                                  alt="admin-icon"
                                  className="admin-icon"
                                />
                              </Tooltip>
                            </span>
                            {sidebarOpen && (
                              route.path ? (
                                <NavLink to={`/${route.path}`}>
                                  {route.main_Router}
                                </NavLink>
                              ) : (
                                <NavLink
                                  onClick={() => setSidebarOpen(false)}
                                  to={`/${route.main_Router.toLowerCase()}`}
                                >
                                  {route.main_Router}
                                </NavLink>
                              )
                            )}
                          </div>
                        </div>
                      ))}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <Tooltip
                        title="Logout"
                        placement="right"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: "14px",
                            },
                          },
                        }}
                      >
                        <img
                          src={logoutIcon}
                          alt="logout"
                          style={{ height: "28px" }}
                          onClick={handleLogoutClick}
                        />
                      </Tooltip>
                      {sidebarOpen && (
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                          onClick={handleLogoutClick}
                        >
                          Logout
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default Sidebar;